import type { ParcelSnapshot } from '../types';
import { projectIssues } from './project';
import type { ProjectionContext, ProjectionInput } from './types';

/** An explicitly empty municipal scan cannot establish that prior issues disappeared. */
export function shouldProjectPropertyIssues(snapshot: ParcelSnapshot) {
  return !(
    snapshot.health.complete &&
    snapshot.health.sources?.length === 0 &&
    snapshot.records.length === 0 &&
    !snapshot.assessor &&
    !snapshot.recorder &&
    !snapshot.subdivision &&
    !snapshot.publicWorks &&
    !snapshot.sf311 &&
    !snapshot.safetyCompliance
  );
}

/** Source projection versions belong to the pinned policy, not the delivery service. */
export function projectPropertyIssues(
  previous: ProjectionInput,
  snapshot: ParcelSnapshot,
  context: Omit<ProjectionContext, 'collectorScope' | 'parserVersion' | 'policyVersion'>,
) {
  return projectIssues(previous, snapshot, {
    ...context,
    collectorScope: 'full',
    parserVersion: 11,
    policyVersion: 1,
  });
}
